import { ChangeDetectionStrategy, Component, Injector, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { EditPanelV2Component } from '@Work/Accounts/proprietary/controls/form-controls/edit-panel/edit-panel-v2.component';
import { DocumentObjectService } from '@Core/models/proprietary/document/document-object.service';
import { MultiDocumentObjectService } from '@Core/models/proprietary/document/multidocument-object.service';
import { MultiDocumentObjectState } from '@Core/models/proprietary/document/multidocument-object.state';
import { PageObjectService } from '@Core/models/proprietary/page/page-object.service';
import { SearchService } from '@Core/services/proprietary/search.service';

@Component({
    standalone: false,
    selector: 'ep-document-info-edit-panel',
    templateUrl: './multi-document-info-edit-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiDocumentInfoEditPanelComponent extends EditPanelV2Component {
    ignorePageState = true; // overrides automatic readonly, error display mode from page state
    readOnlyMode = false; //override readonly mode

    @Input()
    docID: string;

    constructor(
        private multiDocOS: MultiDocumentObjectService,
        private documentOS: DocumentObjectService,
        private pageOS: PageObjectService,
        private injector: Injector,
        private searchSrv: SearchService
    ) {
        super(injector);

        this.config = {
            objectService: this.multiDocOS,
            formMapping: [
                {
                    formGroupName: 'Document',
                    nodeType: 'Document',
                    data$: this.store.select(MultiDocumentObjectState.documentByID).pipe(map((fn) => fn(this.docID))),
                    updateMethod: (data: any) => {
                        this.multiDocOS.updateDocument(data);
                    }
                }
            ]
        };

        this.form = new UntypedFormGroup(
            {
                Document: this.fb.group({
                    Doc_ID: [''],
                    Edit_Status: [''],
                    Doc_Name: [''],
                    Doc_Desc: [''],
                    Doc_Class: [''],
                    Created_By: this.fb.group({
                        Entity_ID: [''],
                        Entity_Name: [''],
                        Date: ['']
                    }),
                    Last_Revised_By: this.fb.group({
                        Entity_ID: [''],
                        Entity_Name: [''],
                        Date: ['']
                    }),
                    Filed_Ind: [''],
                    Protected_Ind: [''],
                    Sent_Ind: ['']
                })
            },
            { updateOn: 'blur' }
        );
    }
}
